import { isBoolean } from 'lodash';

export const WIDGET_TYPES = {
  CORE: 'core',
  I_FRAME: 'iFrame',
  MODULE: 'module',
};

export const WIDGET_MODES = {
  TEST: 'test',
  PUBLISHED: 'published',
};

class WidgetModel {
  constructor(options) {
    this.id = options.id;
    this.name = options.name;
    this.description = options.description;
    this.type = options.type;
    this.enabled = options.enabled;
    this.skillIds = options.skillIds;
    this.mode = options.mode;
    this.url = options.url;
    this.deleted = options.deleted;
    this.parameters = options.parameters;
    this.order = options.order;
    this.span = options.span;
    this.config = options.config || {}; // { fallbackUrl: String, fallbackUrlTimeout: String }
    this.componentName = options.componentName;
    this.path = options.path;
    this.moduleComponent = undefined;
    this.local = isBoolean(options.local) ? options.local : false;
  }

  set component(value) {
    this.moduleComponent = value;
  }

  get component() {
    return this.moduleComponent;
  }
}

export default WidgetModel;
